import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import gql from 'graphql-tag';
import {
  INTEGRATION_SERVICE_V2_AWS_CONFIG,
  INTEGRATION_SERVICE_V3_AWS_CONFIG,
  MESSAGEBIRD_ENDPOINT,
} from '../env/Configurations';
import { getChatMsgStatus, getFutureBookingArrivalList } from '../graphql/dashboard/queries';
import { getCurrentJwtToken, getEncodedValue } from './authUtils';

const integrationServiceV2Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V2_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V2_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV3Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V3_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V3_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const invokeSMS = (body) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  };

  return fetch(MESSAGEBIRD_ENDPOINT, requestOptions);
};

export const getArrivalList = async (hotelId, date) => {
  return await integrationServiceV2Client.query({
    query: gql(getFutureBookingArrivalList),
    variables: getEncodedValue({ hotelId, date }),
    fetchPolicy: 'network-only',
  });
};

export const getMsgStatuslList = async (hotelId, reservationIds) => {
  return await integrationServiceV3Client.query({
    query: gql(getChatMsgStatus),
    variables: getEncodedValue({ hotelId, reservationIds }),
    fetchPolicy: 'network-only',
  });
};
